import React from 'react';
import { string } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';

import { propTypes } from '../../../../../../util/types';
import { BookingParticipantBreakdown, BookingTimeBreakdown } from '../../../../../../components';

import css from './DetailsBookingInfo.module.css';

const DetailsBookingInfo = (props) => {
  const { className, transaction, intl } = props;
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <BookingTimeBreakdown
        className={css.bookingTimeBreakdown}
        transaction={transaction}
        withTitle
      />
      <BookingParticipantBreakdown
        className={css.bookingParticipantBreakdown}
        transaction={transaction}
      />
    </div>
  );
};

DetailsBookingInfo.defaultProps = {
  className: null,
};

DetailsBookingInfo.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  transaction: propTypes.transaction.isRequired,
};

export default injectIntl(DetailsBookingInfo);
